export default "__VITE_ASSET__BUCw6A8___"